import '@babel/polyfill'
import './polyfill.js'
import Vue from 'vue'
import VueCarousel from 'vue-carousel'
import App from './App.vue'
import router from './router'
import store from './store/store'
import i18n from './i18n'
import * as VueGoogleMaps from 'vue2-google-maps'
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'
import VueFullPage from 'vue-fullpage.js'

Vue.use(VueFullPage)

Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyA-m__RJLcSuCbp6W0_ooPxx0lq-bPKaiA', // TODO: put in env vars
    libraries: 'places'
  }
})

const datepickerOptions = {
  sundayFirst: false,
  dateLabelFormat: 'dddd, MMMM D, YYYY',
  days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
  daysShort: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  monthNames: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ],
  colors: {
    selected: '#254655',
    inRange: '#D7900A',
    selectedText: '#fff',
    text: '#565a5c',
    inRangeBorder: '#33dacd',
    disabled: '#fff',
    hoveredInRange: '#254655'
  },
  texts: {
    apply: 'APPLY',
    cancel: 'RESTORE',
    keyboardShortcuts: 'Keyboard Shortcuts'
  }
}

Vue.use(AirbnbStyleDatepicker, datepickerOptions, VueCarousel)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
